import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card } from "@/components/ui/card";
import AuthShell from "@/components/AuthShell";
import SiteFooter from "@/components/SiteFooter";
import { toast } from "sonner";
import { ChevronLeft } from "lucide-react";

export default function ForgotPassword() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e?.preventDefault();
    if (!email) {
      toast.error("Please enter your email");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Reset link sent to your email");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not send reset link");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <AuthShell />
      <div className="max-w-md mx-auto px-6 py-16">
        {sent ? (
          <Card className="p-8">
            <h1 className="text-3xl mb-2">Check your email.</h1>
            <p className="text-muted-foreground mb-6">
              We've sent a password reset link to <strong>{email}</strong>. Check your inbox and spam folder.
            </p>
            <p className="text-sm text-muted-foreground mb-6">
              The link expires in 1 hour.
            </p>
            <Button onClick={() => nav("/login")} className="w-full h-11 font-bold">
              Back to login
            </Button>
          </Card>
        ) : (
          <Card className="p-8">
            <h1 className="text-3xl mb-2">Reset your password.</h1>
            <p className="text-muted-foreground mb-8">
              Enter your email and we'll send a reset link.
            </p>
            <form onSubmit={submit} className="space-y-4">
              <Input
                placeholder="you@business.com"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={busy}
              />
              <Button type="submit" disabled={busy} className="w-full h-11 font-bold">
                {busy ? "Sending..." : "Send reset link"}
              </Button>
            </form>
            <div className="text-center mt-6">
              <Link
                to="/login"
                className="text-sm text-primary font-bold flex items-center justify-center gap-1 hover:underline"
              >
                <ChevronLeft className="w-4 h-4" />
                Back to login
              </Link>
            </div>
          </Card>
        )}
      </div>
      <SiteFooter />
    </div>
  );
}
